import { render, staticRenderFns } from "./SecretKey.vue?vue&type=template&id=04cfd964&"
import script from "./SecretKey.vue?vue&type=script&lang=ts&"
export * from "./SecretKey.vue?vue&type=script&lang=ts&"
import style0 from "./SecretKey.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports